module.exports = __webpack_public_path__ + "static/media/banner_1.c2d72e67.png";